import type React from "react";
import { useMemo } from "react";
import { i18nFilter } from "app/filters/i18nFilter";
import { percentageFilter } from "app/filters/ngFilters";
import { BoxContainer, LoaderContainer, TitleContainer } from "./TotalVisitsComponentsStyledComponents";
import Chart from "pro-features/components/Chart/src/Chart";
import { getPieChartConfig, getPieChartStyle } from "./PieChartConfig";
import { NoDataLandscape } from "pro-features/components/NoData/src/NoData";
import { WidgetTitle } from "app/components/widget-title/WidgetTitle";
import type { IPieChartComponentProps } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewTraffic/Types";
import { WidgetLoader } from "app/components/widget-loader/WidgetLoader";

export const PieChartComponent: React.FunctionComponent<IPieChartComponentProps> = ({
    isLoading,
    isError,
    subtitleFilters,
    chartData,
    a2d,
    tooltip,
    title,
    addMarginRight = true,
}) => {
    const i18n = i18nFilter();
    const { chartConfig, chartStyle } = useMemo(() => {
        return {
            chartConfig: getPieChartConfig({ type: "pie", filter: percentageFilter }),
            chartStyle: getPieChartStyle(),
        };
    }, []);
    return (
        <BoxContainer addMarginRight={addMarginRight}>
                <>
                    <TitleContainer>
                        <WidgetTitle
                            title={i18n(title)}
                            tooltip={i18n(tooltip)}
                            filters={subtitleFilters}
                            addToDashboard={a2d}
                        />
                    </TitleContainer>
                    {isLoading && (
                        <LoaderContainer>
                            <WidgetLoader />
                        </LoaderContainer>
                    )}
                    {chartData && (
                        <div style={{ margin: "16px 20px 15px" }}>
                            <Chart
                                type={"pie"}
                                config={chartConfig}
                                data={chartData}
                                domProps={chartStyle}
                            />
                        </div>
                    )}
                    {(!chartData || isError) && !isLoading && (
                        <LoaderContainer>
                            <NoDataLandscape
                                title="global.nodata.notavilable"
                                subtitle={null}
                            />
                        </LoaderContainer>
                    )}
                </>
            </BoxContainer>
    );
};
